<template>
    <div class="topbar-component d-flex justify-content-between align-items-center">
        <div class="page-heading">
            {{ this.$route.name }}
        </div>
        <div class="d-flex justify-content-end align-items-center">
            <Button severity="secondary" class="gap"  text rounded size="small" icon="pi pi-bell" />
            <Button @click="showSidebar = true" severity="secondary" text rounded size="small" icon="pi pi-question" />
        </div>
        <Sidebar v-model:visible="showSidebar" :autoZIndex="false" :dismissable="false" :modal="false" position="right">
            <p class="page-heading">Page help</p>
            <p>{{ pageHelpMap[this.$route.path] }}</p>
            <p class="guideline"> As per TRAI's directions under TCCCPR-2018, 'only whitelisted URLs/APKs/OTT links/call back numbers shall be allowed  in the content template'. For further details you can refer to <a href="https://www.trai.gov.in/sites/default/files/PR_No.42of2023.pdf">https://www.trai.gov.in/sites/default/files/PR_No.42of2023.pdf</a>. </p>
        </Sidebar>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import Sidebar from 'primevue/sidebar'
import badge from 'primevue/badgedirective'

export default {
    name: 'SideBar',
    components: {
        Sidebar
    },
    directives: {
        badge
    },
    data () {
        return {
            showSidebar: false,
            pageHelpMap: {
                '/': 'Dasbhoard gives you various metrics on whitelisted CTAs for a given timeframe.',
                '/cta': `Portal allows you to whitelist different types of call to actions like URLs, numbers, emails, OTT links, APK links etc. The status of a call to action has to be "whitelisted" for it to be allowed in the messages. To whitelist a new call to action, click on ' + Whitelist CTA ' button. This will redirect you to a configuration page to add CTA.`,
                '/cta/whitelist': `Portal allows you to whitelist different types of call to actions like URLs, numbers, emails, OTT links, APK links etc. The status of a call to action has to be "whitelisted" for it to be allowed in the messages. To whitelist a new call to action, click on ' + Whitelist CTA ' button. This will redirect you to a configuration page to add CTA.`,
                '/subscription': 'This section allows you to take subcription to url shortening service and you can also view the subcription details',
                '/link': `URL shortner allows you to shorten the URL which is whitelisted. You can select the domain, custom back halves, length of short url, short link protocol etc to configure the shortner parameters. Link level reports are placed in the view detials section. This shows the clicks trend for the mentioned time frame.`,
                '/link/create': `URL shortner allows you to shorten the URL which is whitelisted. You can select the domain, custom back halves, length of short url, short link protocol etc to configure the shortner parameters. Link level reports are placed in the view detials section. This shows the clicks trend for the mentioned time frame.`,
                '/link/report': `URL shortner allows you to shorten the URL which is whitelisted. You can select the domain, custom back halves, length of short url, short link protocol etc to configure the shortner parameters. Link level reports are placed in the view detials section. This shows the clicks trend for the mentioned time frame.`,
                '/domain': `This section allows you to add your branded short domains. These short domains can be used to generate the short links. In order to add the short domain to the portal, the mentioned IPs are to be added as type A records in the DNS settings. In order to shorten the URLs with https protocol, it is mandatory to upload the SSL certificates in step 2.`,
                '/domain/create': `This section allows you to add your branded short domains. These short domains can be used to generate the short links. In order to add the short domain to the portal, the mentioned IPs are to be added as type A records in the DNS settings. In order to shorten the URLs with https protocol, it is mandatory to upload the SSL certificates in step 2.`,
                '/analytics': `Analytics page gives various metrics on the whitelisted call to actions. This includes the aggregaged clicks from various URLs for a given timeframe.`,
                '/webhook': `This section allows you to configure webhook to which a copy of the click data will be submitted.`,
                '/accountsettings': 'This section allows you to configure the default short domain and other mandatory parameters to shorten the whitelisted URL. If there is no configuraion in the URL shortener section, the parameters in the default settings will be picked to shorten a whitelisted URL.',
                '/appbranding': `Application Header Customise the branding of the application header to include your organization's logo`,
                '/users': ''
            }
        }
    },
    methods: {

    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters({ currentUser: 'currentUser' })
    },
    mounted () {
    }
}
</script>

<style>
.topbar-component {
    padding: 0 2rem 0;
}
.guideline {
    word-break: break-all;
}
</style>
